// This is for the Zebra Label printing library.
// This wraps the framework and adds specific logic and view to suit our needs.

// NOTE: This adds `global.BrowserPrint = BrowserPrint;` (etc) to make these work
import './BrowserPrint-3.1.250.min' /* global BrowserPrint:false */
// import './BrowserPrint-Zebra-1.1.250.min' /* global Zebra:false */
import { sortBy, filter, uniq } from 'lodash'
import Raven from 'raven-js'
import moment, { displayFormat } from 'helpers/moment'
import { compareParseInt } from 'helpers/index'
import { getBins } from 'helpers/orders'

// Settings calibrated for TwoXSea
// …
// 2025-02-14: X=250, Y=40
// 2026-09-18: X=450, Y=0
const defaultX = 450
const defaultY = 0
const defaultFont = 28
const defaultFontLarge = 32

window.ZEBRA_X = defaultX
window.ZEBRA_Y = defaultY
window.ZEBRA_FONT = defaultFont
window.ZEBRA_FONT_LARGE = defaultFontLarge

const getSettings = () => ({
  // All of these values control the printing
  testPrint: window.ZEBRA_TEST || false,
  x: Number(window.ZEBRA_X || defaultX),
  y: Number(window.ZEBRA_Y || defaultY),
  font:  Number(window.ZEBRA_FONT || defaultFont),
  largeFont:  Number(window.ZEBRA_FONT_LARGE || defaultFontLarge),
})

const getPrinter = async () => {
  const device = await new Promise(resolve => {
    // Get the default device from the application as a first step. Discovery takes longer to complete.
    BrowserPrint.getDefaultDevice("printer", function(device) {
      resolve(device)
    }, function(error){
      alert('Could not find printer: ' + error)
    })
  })

  return device
}

const ordersArray = (orders) => {
  const array = []

  // get a unique list of customer_ids, grab their orders, and then add those orders to the array
  uniq(orders.map(o => o.customer_id))
    .forEach(customerId => {
      // sort orders by product name
      sortBy(
        // get orders for this customer
        filter(orders, (o) => compareParseInt(customerId, o.customer_id)),
        'route.name'
      ).forEach((o, i) => { // forEach customer's order, sorted
        array.push(o)
      })
    })

  return array
}

const printOrder = async (order)  => {
  const customer = `${order.customer.name} (${moment(order.date).format(displayFormat)})`
  const route = `Route ${order.route.name}${order.bin && ` • ${order.bin} ` || ''}`
  const product = `${order.qty} ${order.uom.shorthand || order.uom.name || ''} ${order.option && order.option.name || ''} - ${order.product.name}`
  const notes = typeof order.notes === 'string' ? `> ${order.notes.replace(/\n/g, ' ')}` : ''

  const { x, y, font, largeFont } = getSettings()

  // This data is intended for use with Dymo 30252 labels
  const data = `
    ^XA
    ^FWR
    ^CI28

    ^FX Customer field
    ^FO${x},${y},2
    ^A0R${font},${font}^FD${customer}^FS

    ^FX Route field
    ^FO${x-font*1.65},${y},2
    ^A0R${font},${font}^FD${route}^FS

    ^FX Product field
    ^FO${x-font*1.4-font-largeFont},${y},2
    ^A0R${largeFont},${largeFont}^FD${product}^FS

    ^FX Notes field
    ^FO${x-font*1.4-font-largeFont-font*1.65},${y},2
    ^A0R${font},${font}^FD${notes}^FS
    ^XZ
  `

  try {
    const printer = await getPrinter()

    printer.send(data)
  } catch (error) {
    throw error
  }
}

export const print = async (orders) => {
  let count = 0
  const printOrders = ordersArray(orders).map(order => {
    const bins = getBins(order)

    if (!bins || bins.length <= 1) {
      count++
      return order
    }

    return bins.map((qty, i) => {
      let binOrder = Object.assign({}, order, {
        qty,
        bin: `Bin ${i + 1}/${bins.length}`
      })

      count++
      return binOrder
    })
  }).flatten()

  if (count < orders.length) {
    Raven.captureException(new Error('Printed less labels than orders!'), {
      extra: {
        count,
        orders: orders.map(o => o.id)
      }
    })
  }

  if (getSettings().testPrint) {
    return await printOrder(printOrders[0])
  }

  for (const order of printOrders) {
    await printOrder(order)
  }
}



// WEBPACK FOOTER //
// ./src/vendor/zebra/index.js